import { render, staticRenderFns } from "./customer_detail.vue?vue&type=template&id=75b53ff7&scoped=true&"
import script from "./customer_detail.vue?vue&type=script&lang=js&"
export * from "./customer_detail.vue?vue&type=script&lang=js&"
import style0 from "./customer_detail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./customer_detail.vue?vue&type=style&index=1&id=75b53ff7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b53ff7",
  null
  
)

export default component.exports